export const APPLE_WALLET_PAYMENT_OFFER_RESULT_URL = 'https://wallet.apple.com/paymentOfferActionResult'
